import createConversionMap from '@shared/helpers/object-converter';

export interface ISCDUserDto {
    companyCode?: string;
    country: string;
    department: string;
    departmentText: string;
    displayName: string;
    firstName: string;
    gender: string;
    gid: string;
    graduateTitle: string;
    id: number;
    initials: string;
    location: string;
    mail: string;
    mobile: string;
    selected?: boolean;
    surName: string;
}

export interface ISCDUser {
    company?: string;
    country?: string;
    department?: string;
    departmentText?: string;
    eMail?: string;
    firstName?: string;
    fullName?: string;
    gender?: string;
    id?: string;
    lastName?: string;
    title?: string;
    userLocation?: string;
}

export const scdUserConversionMap = createConversionMap<ISCDUserDto, ISCDUser>()
    .from('gid')
    .to('id')
    .from('firstName')
    .to('firstName')
    .from('surName')
    .to('lastName')
    .from('mail')
    .to('eMail')
    .from('department')
    .to('department')
    .from('graduateTitle')
    .to('title')
    .from('gender')
    .to('gender')
    .from('departmentText')
    .to('departmentText')
    .from('gender')
    .to('gender')
    .from('country')
    .to('country')
    .from('location')
    .to('userLocation')
    .from(null)
    .to('company', (e: ISCDUserDto) =>
        e.department?.startsWith('SHS')
            ? 'Siemens Healthineers'
            : e.department?.startsWith('SE')
              ? 'Siemens Energy'
              : e.department
                ? 'Siemens AG'
                : 'N/A'
    )
    .from(null)
    .to('fullName', e => `${e.graduateTitle ? e.graduateTitle + ' ' : ''}${e.firstName} ${e.surName}`);

export const scdUserConverter = {
    toApi: scdUserConversionMap.build(),
    toApiMulti: scdUserConversionMap.buildMulti()
};
